import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import VueSweetalert2 from "vue-sweetalert2";
import MaterialDashboard from "./material-dashboard";
import { initializeMsal } from "./plugins/msal";
import posthogPlugin from "./plugins/posthog";
import { handleAuthResponse } from "./services/auth.service";
import { cleanupStaleSessionData } from "./utils/sessionCleanup";

/* Import Font Awesome */
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { 
    faMagnifyingGlass, 
    faEllipsisVertical, 
    faDownload, 
    faTrash, 
    faLocationDot,
    faCrown, 
    faArrowUpRightFromSquare,
    faShareNodes,
    faCopy,
    faEnvelope,
    faHeart,
    faAddressBook,
    faUserPlus,
    faPencil,
    faPlus
} from '@fortawesome/free-solid-svg-icons';

/* Add icons to the library */
library.add(
    faMagnifyingGlass,
    faEllipsisVertical,
    faDownload,
    faTrash,
    faLocationDot,
    faCrown,
    faArrowUpRightFromSquare,
    faShareNodes,
    faCopy,
    faEnvelope,
    faHeart,
    faAddressBook,
    faUserPlus,
    faPencil,   
    faPlus
);

async function bootstrapApp() {
    // Clean up any stale session data first
    cleanupStaleSessionData();
    
    const instance = await initializeMsal();

    if (!instance) {
        console.error("❌ Failed to initialize MSAL. App will not start.");
        return;
    }

    await handleAuthResponse();

    const appInstance = createApp(App);
    appInstance.config.globalProperties.$msalInstance = instance;
    appInstance.use(store);
    
    // Add error handling for router installation
    try {
        appInstance.use(router);
    } catch (error) {
        console.error("❌ Failed to install router:", error);
        // If router fails, we can still mount the app but navigation won't work
        // This prevents the entire app from crashing
    }
    
    appInstance.use(VueSweetalert2);
    appInstance.use(MaterialDashboard);
    appInstance.use(posthogPlugin);
    appInstance.component('FontAwesomeIcon', FontAwesomeIcon); // Register Font Awesome component
    
    // Expose store globally for use in setNavPills
    window.$store = store;
    
    appInstance.mount("#app");
    
    // Trigger a resize event after mount to ensure proper component dimensions
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 200);
}

bootstrapApp();